import { useState } from "react";
import { MerchantOverview } from "./MerchantOverview";
import { MerchantProducts } from "./MerchantProducts";
import { MerchantCategories } from "./MerchantCategories";
import { MerchantDiagnostics } from "./MerchantDiagnostics";
import { MerchantSettings } from "./MerchantSettings";

const VIEWS = [["overview", "Overview"], ["products", "Products & Errors"], ["categories", "Category Mapping"],
  ["diagnostics", "Diagnostics & Shipping"], ["settings", "Settings & Alerts"]];

export default function MerchantTab() {
  const [view, setView] = useState("overview");
  const [filter, setFilter] = useState({});
  const openProducts = (f) => { setFilter(f); setView("products"); };
  return (
    <div data-testid="merchant-center">
      <div className="flex flex-wrap gap-2 mb-5">
        {VIEWS.map(([id, label]) => (
          <button key={id} onClick={() => setView(id)} data-testid={`gmc-view-${id}`}
            className={`px-3 py-1.5 rounded-full text-sm font-semibold transition-colors ${view === id ? "bg-steel text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{label}</button>))}
      </div>
      {view === "overview" && <MerchantOverview onOpen={openProducts} />}
      {view === "products" && <MerchantProducts initial={filter} key={JSON.stringify(filter)} />}
      {view === "categories" && <MerchantCategories />}
      {view === "diagnostics" && <MerchantDiagnostics />}
      {view === "settings" && <MerchantSettings />}
    </div>
  );
}
